import AbstractCommand from "../../../../../shared/src/ranj/app/core/AbstractCommand";
import SkinKeys from "../../../../../shared/src/ranj/app/ui/SkinKeys";
import GameConfig from "../model/GameConfig";
import SaveModel from "../model/SaveModel";


export default class StartGameCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveModel} saveModel 
     * @param {GameConfig} gameConfig 
     */
    constructor(dispatcher, saveModel, gameConfig) {
        super(dispatcher);

        this.execute = function(event) {
            const savegame = saveModel.getSaveGame();
            if (savegame && savegame.elapsed >= gameConfig.time * 1000) {
                this.gotoScreen(SkinKeys.END_SCREEN);
            } else {
                this.gotoScreen(SkinKeys.GAME_SCREEN);
            }
        };
    };

}